import { StyleSheet, Text, View } from "react-native";
import { SelectList } from "react-native-dropdown-select-list";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function TablePrice({ select, setSelected, isValid = true, invalidMessage = "", tableList }) {
  const data = [];


  try {
    if (!!tableList) {
      if (tableList.length > 0) {
        tableList.map((tablePrice, index) => {
          data.push({ key: { id: tablePrice.id, value: tablePrice }, value: tablePrice.name + " (" + formatMoneyBRL(tablePrice.price) + ")" })
        })
      }
    }
  } catch (e) {
  }

  return (
    <>
      <SelectList
        setSelected={(val) => setSelected(val)}
        data={data}
        save="key"
        placeholder={"Selecione uma tabela de preço"}
        notFoundText={"Nenhuma tabela encontrada"}
        inputStyles={{
          fontSize: Fonts.FONT_SIZE_18,
          color: select ? Colors.BLACK : Colors.GRAY_DARK,
        }}
        boxStyles={{
          // backgroundColor: Colors.WHITE,
          borderColor: isValid ? Colors.BLACK : Colors.ALERT,
          borderWidth: 1,
          borderRadius: 8,
          height: 55,
        }}
        dropdownTextStyles={{
          fontSize: Fonts.FONT_SIZE_18,
        }}
        dropdownStyles={{
          borderRadius: 8,
        }}
        searchPlaceholder={"Pesquisar"}
      />
      {!isValid ? (
        <View style={styles.viewValidator}>
          <Icon name="alert-circle" color={Colors.ALERT} />
          <Text style={styles.validator}>{invalidMessage}</Text>
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  validator: {
    color: Colors.ALERT,
    marginLeft: 3,
  },
  viewValidator: {
    flexDirection: "row",
    alignItems: "center",
    alignContent: "flex-start",
    marginBottom: 20,
    // width: "70%"
  },
});
